<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loadingConfig"
    >
      <b-table
        hover
        striped
        :fields="columns"
        :items="services"
        selectable
        select-mode="single"
        @row-selected="onServiceSelected($event[0])"
      />
    </b-overlay>
  </div>

</template>

<script>
import { BTable, BOverlay } from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'

export default {
  components: {
    BTable, BOverlay,
  },
  props: {
    selectedZone: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    const columns = [
      'service',
      'class',
    ]
    const formatServices = services => services.map(el => {
      const serviceData = el.split('::')
      const [serviceName, serviceClass] = serviceData
      return {
        service: serviceName,
        class: serviceClass,
      }
    })

    const services = ref([])
    const loadingServices = ref(false)
    const fetchZoneServices = () => {
      loadingServices.value = true
      ctx.root.$store.dispatch('zones/fetchZonesServices', props.selectedZone).then(result => {
        console.log(result[0])
        services.value = formatServices(result)
        loadingServices.value = false
      })
    }
    const loadingConfig = ref(false)
    const tripConfigRoutePush = (pushType, service) => {
      ctx.root.$router.push(`/trip-config/${pushType}/${props.selectedZone}/${service}`)
    }
    const onServiceSelected = async event => {
      const selectedService = `${event.service}::${event.class}`
      try {
        loadingConfig.value = true
        await ctx.root.$store.dispatch('tripConfig/fetchTripConfig', {
          zone: props.selectedZone,
          service: selectedService,
        })
        tripConfigRoutePush('edit', selectedService)
      } catch (error) {
        tripConfigRoutePush('new', selectedService)
        console.log(error)
      }
    }
    watch(loadingServices, () => {
      ctx.emit('services-loading-state', loadingServices.value)
    }, { immediate: true })
    fetchZoneServices()
    return {
      services,
      columns,
      onServiceSelected,
      loadingConfig,
    }
  },
}
</script>

<style>

</style>
